import { apiFetch } from './client';
import type { User } from '$lib/types';

export const fetchMe = () => apiFetch<User>('/auth/me');

export const updateMyLocale = (locale: User['locale']) =>
  apiFetch<User>('/auth/me', { method: 'PATCH', body: JSON.stringify({ locale }) });
